import React, { createContext, useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { safeGetJSON, safeSetJSON } from "../../utils/safeStorage";

export const TourContext = createContext();

export function TourProvider({ children }) {
    const location = useLocation();
    const [steps, setSteps] = useState([]);
    const [current, setCurrent] = useState(null);
    const [active, setActive] = useState(false);
    const [hiddenPages, setHiddenPages] = useState([]);
    const [end, setEnd] = useState(true);

    const normalizePath = (path) => {
        const parts = path.split("/").filter(Boolean);
        const limited = parts.slice(0, 3);
        return "/" + limited.join("/");
    };

    useEffect(() => {
        const parsed = safeGetJSON("guides", [], 'array');
        setHiddenPages(parsed);
    }, [location.pathname]);

    const hideGuideForever = (page) => {
        const basePath = normalizePath(page);
        if (!hiddenPages.includes(basePath)) {
            const updated = [...hiddenPages, basePath];
            setHiddenPages(updated);
            safeSetJSON("guides", updated);
            setActive(false);
        }
    };

    const canShowGuide = (page) => {
        const basePath = normalizePath(page);
        return !hiddenPages.includes(basePath);
    };

    return (
        <TourContext.Provider
            value={{
                steps,
                setSteps,
                current,
                setCurrent,
                active,
                setActive,
                hiddenPages,
                hideGuideForever,
                canShowGuide,
                end,
                setEnd,
            }}
        >
            {children}
        </TourContext.Provider>
    );
}

export const useTour = () => useContext(TourContext);